import React from 'react'
import { getId } from '@src/containers/UtmGenerator/helpers'

export const ParametersData = {
  required: [
    {
      fieldName: 'utmSource',
      title: 'Источник трафика',
      text: 'utm_source',
      id: getId(),
      inputInfo: {
        type: 'text',
        inputMode: 'text',
        id: getId(),
        name: 'utmSource',
        labelTextMap: {
          yourValues: 'google, yandex, vkontakte, mycom',
          googleAds: 'google, yandex, vkontakte, mycom',
          yandexDirect: 'google, yandex, vkontakte, mycom',
          vkontakte: 'google, yandex, vkontakte, mycom',
          mytarget: 'google, yandex, vkontakte, mycom'
        }
      },
      tooltipWidth: '443px',
      tooltipDirectionMob: 'bottom',
      tooltipContent: (
        <>
          <p>utm_source — это название источника, из&nbsp;которого получаем трафик.</p>
          Например:
          <ul>
            <li>utm_source=google&nbsp;&mdash; реклама в&nbsp;Google Ads</li>
            <li>utm_source=yandex&nbsp;&mdash; реклама в&nbsp;Яндекс.Директе</li>
            <li>utm_source=facebook&nbsp;&mdash; реклама в&nbsp;Facebook Ads</li>
            <li>utm_source=vk&nbsp;&mdash; реклама во&nbsp;ВКонтакте</li>
            <li>utm_source=mycom&nbsp;&mdash; реклама в&nbsp;myTarget</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      title: 'Тип рекламы (канал)',
      text: 'utm_medium',
      fieldName: 'utmMedium',
      inputInfo: {
        type: 'text',
        inputMode: 'text',
        id: getId(),
        name: 'utmMedium',
        labelTextMap: {
          yourValues: 'cpc',
          googleAds: 'cpc',
          yandexDirect: 'cpc',
          vkAds: 'cpc',
          vkontakte: 'cpc',
          mytarget: 'cpc'
        }
      },
      tooltipWidth: '443px',
      tooltipDirectionMob: 'bottom',
      tooltipContent: (
        <>
          <p>
            utm_medium&nbsp;&mdash; это тип рекламы. Также его называют рекламным каналом. Советуем
            использовать устоявшиеся параметры.
          </p>
          Например:
          <ul>
            <li>utm_medium=organic&nbsp;&mdash; органический трафик, бесплатные переходы</li>
            <li>utm_medium=cpc&nbsp;&mdash; контекстная реклама (плата за&nbsp;клик)</li>
            <li>utm_medium=email&nbsp;&mdash; рассылка</li>
            <li>utm_medium=social&nbsp;&mdash; социальные сети</li>
            <li> utm_medium=banner&nbsp;&mdash; медийная реклама</li>
            <li>utm_medium=cpa&nbsp;&mdash; другая реклама (плата за&nbsp;действие)</li>
            <li>utm_medium=display&nbsp;&mdash; баннерная реклама (плата за&nbsp;показы)</li>
            <li>utm_medium=social_cpc&nbsp;&mdash; реклама в&nbsp;соцсетях (плата за&nbsp;клик)</li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      title: 'Название кампании',
      text: 'utm_campaign',
      fieldName: 'utmCampaign',
      inputInfo: {
        type: 'text',
        inputMode: 'text',
        id: getId(),
        name: 'utmCampaign',
        labelTextMap: {
          yourValues: 'bags_spring_sale',
          googleAds: '{network}',
          yandexDirect: '{campaign_id}',
          vkAds: '{campaign_id}',
          vkontakte: '{campaign_id}',
          mytarget: '{{campaign_id}}'
        }
      },
      tooltipWidth: '443px',
      tooltipDirectionMob: 'bottom',
      tooltipContent: (
        <>
          <p>
            utm_campaign&nbsp;&mdash; это название кампании. Название кампании может быть любым.
            Постарайтесь сделать его максимально понятным, чтобы не&nbsp;перепутать кампании.
          </p>
          Например:
          <ul>
            <li>utm_campaign=bags_spring_sale&nbsp;&mdash; реклама весенней распродажи сумок</li>
          </ul>
        </>
      )
    }
  ],
  optional: [
    {
      id: getId(),
      title: 'Дополнительная информация',
      text: 'utm_content',
      fieldName: 'utmContent',
      inputInfo: {
        type: 'text',
        inputMode: 'text',
        id: getId(),
        name: 'utmContent',
        labelTextMap: {
          yourValues: 'banner_1280×720',
          googleAds: '{creative}',
          yandexDirect: '{ad_id}',
          vkAds: '{ad_id}',
          vkontakte: '{ad_id}',
          mytarget: '{{ad_id}}'
        }
      },
      tooltipWidth: '443px',
      tooltipDirectionMob: 'bottom',
      tooltipContent: (
        <>
          <p>
            utm_content&nbsp;&mdash; это дополнительная информация. <br /> Поможет различить ссылки,
            в&nbsp;которых остальные параметры совпадают. В&nbsp;этом поле можно написать любой
            текст. Советуем указать здесь характеристики объявления: категорию товара или услуги,
            тип объявления, размеры баннера и&nbsp;т.&nbsp;п.
          </p>
          Например:
          <ul>
            <li>
              utm_content=banner_lama_1280&times;720&nbsp;&mdash; баннер с&nbsp;ламой 1280&times;720
            </li>
            <li>
              utm_content=beginner_course_text&nbsp;&mdash; текстовое объявление о&nbsp;курсе для
              начинающих специалистов
            </li>
          </ul>
        </>
      )
    },
    {
      id: getId(),
      title: 'Ключевое слово',
      text: 'utm_term',
      fieldName: 'utmTerm',
      inputInfo: {
        type: 'text',
        inputMode: 'text',
        id: getId(),
        name: 'utmTerm',
        labelTextMap: {
          yourValues: 'free',
          googleAds: '{keyword}',
          yandexDirect: '{keyword}',
          vkAds: 'free',
          vkontakte: 'free',
          facebook: 'free',
          mytarget: '{{geo}}.{{gender}}.{{age}}'
        }
      },
      tooltipWidth: '285px',
      tooltipDirectionMob: 'bottom-start',
      tooltipContent: (
        <>
          utm_term&nbsp;&mdash; это ключевая фраза. Поможет понять, по&nbsp;каким фразам
          показываются объявления.
        </>
      )
    }
  ]
}
